import { Box, Typography } from '@mui/material';
import { FormikErrors } from 'formik';
import React from 'react';

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formikErrors?: FormikErrors<any>;
}

const FormikErrorDisplay: React.FC<Props> = ({ formikErrors }) => {
  if (!formikErrors) return null;

  const errorsExist = Object.keys(formikErrors).length > 0;
  if (!errorsExist) return null;

  return (
    <Box>
      {Object.entries(formikErrors).map(([field, errorMessage]) => {
        let message = `Error with field: ${field}`;
        if (typeof errorMessage === 'string') {
          message = errorMessage;
        } else if (Array.isArray(errorMessage)) {
          message = errorMessage.join(', ');
        }

        return (
          <Typography
            key={field}
            variant='body1'
            sx={{
              color: (theme) => theme.colors.status.red.main,
            }}
            textAlign='center'
            gutterBottom
          >
            {message}
          </Typography>
        );
      })}
    </Box>
  );
};

export default FormikErrorDisplay;
